import Vue from 'vue'
import { toFixed } from 'utils/common'
import choiceFilter from 'utils/choiceFilter'

// 浮点数计算
Vue.filter('floatNum', (value, stock, digits, showZero = true) => {
  if (isNaN(value)) return '--'
  if (!showZero && value === 0) return '--'
  if (typeof digits === 'number') {
    return toFixed(value, digits)
  }
  if (typeof stock === 'object') {
    return toFixed(value, choiceFilter(stock, value))
  }
  return toFixed(value, Number(Math.abs(value)) >= 1 || value === 0 ? 2 : 4)
})
